import type { LiveRoomAnnouncementResponse, VenueRoomStatus } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const venueRoomApi = {
  async status(businessId: string, listingId: string): Promise<VenueRoomStatus> {
    const res = await api.api.businesses[':businessId'].listings[':id']['venue-room'].$get({
      param: { businessId, id: listingId },
    })
    return unwrap<VenueRoomStatus>(res)
  },

  async announce(
    businessId: string,
    listingId: string,
    text: string,
  ): Promise<LiveRoomAnnouncementResponse> {
    const res = await api.api.businesses[':businessId'].listings[':id'][
      'venue-room'
    ].announcements.$post({ param: { businessId, id: listingId }, json: { text } })
    return unwrap<LiveRoomAnnouncementResponse>(res)
  },
}
